<div [id]="id" class="chart-viewport" inViewport (inViewportAction)="loadChart($event)"></div>
